import { React, useContext, useState, useEffect } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import FundSizeFilter from "../../Components/RefineSearchComponents/FundSizeFilter";
import CapitalSourceFilter from "../RefineSearchComponents/CapitalSourseFilter";
import FundSectorFilter from "../RefineSearchComponents/FundSector";
import FundStatusFilter from '../RefineSearchComponents/FundStatusFilter';
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { refineSearchFundStatus } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import Fund from "../RefineSearchComponents/Fund";
import FundInvestor from "../RefineSearchComponents/FundInvestor";
/**
 * The InvestmentRefineSearch function is a React component that renders a form for refining search
 * filters for investment data.
 * @returns The function `InvestmentRefineSearch` is returning a JSX element.
 */
export default function InvestmentRefineSearch({ customPathname }) {
    const { setrefineSearchFilters, onErrorHandler, refineSearchFilters, setMonthPickerValue ,fundsOptions,setFundsOptions,fundInvestorsOptions,setFundInvestorsOptions ,dbDropdown , setDbDropdown ,dropdown } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const { getToken } = useContext(UserContext);
    const [select, setSelected] = useState(0);
    const location = useLocation();
    const {pathname} = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false

    const navigate = useNavigate();

    // State for section navigation and popup control
    const [activeFilterSection, setActiveFilterSection] = useState("fund");
    const [openFilterPopup, setOpenFilterPopup] = useState(null);


    const [FundStatusOptions, setFundStatusOptions] = useState([])
    const [FundStatusSuboptions, setFundStatusSuboptions] = useState([])
    const [FundsStageOptions, setFundsStageOptions] = useState([])
    const [FundsIndustryOptions, setFundsIndustryOptions] = useState([])
    const [CapitalSourceOptions, setCapitalSourceOptions] = useState([])
    const [fundSectorOptions, setFundSectorOptions] = useState([])
    const [MinFundOptions, setMinFundOptions] = useState([])
    const [MaxFundOptions, setMaxFundOptions] = useState([])
    const [isSuboptionsFetch, setisSuboptionsFetch] = useState(false);


   /**
    * The function `applyFilter` filters and updates the refine search filters based on the selected
    * options.
    */
    const applyFilter = () => {

        const selectedStage = FundsStageOptions?.filter(option => option.isChecked);
        const selectedIndystry = FundsIndustryOptions?.filter(option => option.isChecked);
        const selectedCpital = CapitalSourceOptions?.filter(option => option.isChecked);
        const selectedFundSector = fundSectorOptions?.filter(option => option.isChecked);
        const selectedFunds = fundsOptions?.filter(option => option.isChecked);
        const selectedFundInvestors = fundInvestorsOptions?.filter(option => option.isChecked);
        const invMin = MinFundOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const invMax = MaxFundOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedStatus = FundStatusOptions.filter(option => option.isChecked);
        const selectedSubStatus = FundStatusSuboptions.filter(option => option.isChecked);
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {
                ...prev[customPathname],
                fundIndustry: selectedIndystry,
                fundStage: selectedStage,
                capitalSource: selectedCpital,
                fundSector: selectedFundSector,
                fundSize: invMin != null && invMax != null ? [invMin, invMax] : [],
                fundStatus: selectedStatus,
                closeStatus: selectedSubStatus,
                funds:selectedFunds,
                investors:selectedFundInvestors,
            },
        }))
    }

   /**
    * The `resetFilter` function resets a specific filter in the `refineSearchFilters` state object by
    * setting its value to an empty object.
    */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {}
        }))
        setFundInvestorsOptions([])
    }


    // Submitting Refine Search Form 
 /**
  * The function `refineSearchFilter` updates search filters, resets certain values, applies filters,
  * and navigates to a new location if necessary.
  * @param event - The event parameter is an object that represents the event that triggered the
  * function. It contains information about the event, such as the type of event, the target element,
  * and any additional data associated with the event. In this case, it is used to prevent the default
  * behavior of the event, which is
  */
    const refineSearchFilter = (event) => {
        event.preventDefault();
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        setCurrentPage(1);
        applyFilter();
        setSelected(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

  /**
   * The `onResetClick` function resets the current page, filters, and fund status suboptions, and
   * navigates to a custom pathname.
   * @param event - The event parameter is an object that represents the event that triggered the
   * function. It contains information about the event, such as the type of event, the target element,
   * and any additional data associated with the event. In this case, the event is a click event.
   */
    const onResetClick = (event) => {
        event.preventDefault();

        setCurrentPage(1);
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
        const updatedFundStatusSuboptions = FundStatusSuboptions.map((status) => {

            return {
                ...status,
                isChecked: !status.isChecked,
            };
        });
        setFundStatusSuboptions(updatedFundStatusSuboptions)
        setFundInvestorsOptions([])
        setFundsOptions([])

        // console.log(FundStatusSuboptions, 'FundStatusSuboptions');

    }

   /**
    * The function `accordionClick` sets the selected value to either 0 or the provided value.
    * @param val - The `val` parameter is a value that is passed to the `accordionClick` function. It
    * is used to determine whether the accordion should be selected or deselected.
    */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

  /**
   * The function `updateSubOptions` is used to update the sub-options based on the selected option and
   * initial flag.
   * @param selected - The `selected` parameter is the value selected by the user. It represents the
   * statusId that will be used in the API request.
   * @param initial - The `initial` parameter is a boolean value that indicates whether this function
   * is being called for the initial setup or not. If `initial` is `true`, it means that the function
   * is being called during the initial setup and certain additional logic needs to be executed. If
   * `initial` is `false
   * @returns The function does not explicitly return anything.
   */
    const updateSubOptions = (selected, initial) => {
        if (selected == "") {
            setFundStatusSuboptions([])
            return;
        }

        setisSuboptionsFetch(true);
        axios.post(refineSearchFundStatus, {
            "statusId": selected,
            "closeStatusId": "All"
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then((response) => {
            setisSuboptionsFetch(false);
            if (response.status === 200) {
                if (initial === true) {
                    const selectedSub = refineSearchFilters[customPathname]?.closeStatus?.map(value => value.id) ?? [];
                    setFundStatusSuboptions(response.data?.closeStatusList?.map(type => ({ ...type, isChecked: selectedSub.includes(type.id) })))
                } else {
                    setFundStatusSuboptions(response.data?.closeStatusList ?? [])
                }
            }
        }).catch((e) => {
            onErrorHandler(e)
            setisSuboptionsFetch(false);
        })
    }

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.fundStatus?.map(value => value.id) ?? [];

        if ((industryIds?.length ?? 0) !== 0) {
            updateSubOptions(industryIds?.at(0), true)
        }
    }, [customPathname])

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    // Helper function to count active filters in Fund section
    const getFundFiltersCount = () => {
        let count = 0;
        if (fundSectorOptions?.length > 0 && fundSectorOptions.some(opt => opt.isChecked)) count++;
        if ((MinFundOptions?.length > 0 && MinFundOptions.some(opt => opt.isChecked)) || (MaxFundOptions?.length > 0 && MaxFundOptions.some(opt => opt.isChecked))) count++;
        if (FundStatusOptions?.length > 0 && FundStatusOptions.some(opt => opt.isChecked)) count++;
        if (CapitalSourceOptions?.length > 0 && CapitalSourceOptions.some(opt => opt.isChecked)) count++;
        return count;
    };

    // Helper function to count active filters in Show Funds By section
    const getShowFundsByFiltersCount = () => {
        let count = 0;
        if (fundInvestorsOptions?.length > 0 && fundInvestorsOptions.some(opt => opt.isChecked)) count++;
        if (fundsOptions?.length > 0 && fundsOptions.some(opt => opt.isChecked)) count++;
        return count;
    };
    return (
        <div className="bg-white">
            <div className="h-full no-scrollbar">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full">
                    <main className="h-full w-full py-4">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left column - Headers (30%) */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">
                                <div 
                                    className={`cursor-pointer p-3 rounded-lg transition-colors ${
                                        activeFilterSection === "fund" ? "bg-[#BC8B20] text-white" : "hover:bg-gray-100"
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === "fund" ? null : "fund")}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2">
                                            <span className="font-medium">Fund</span>
                                            {getFundFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-2 py-1 min-w-[20px] text-center ${activeFilterSection === "fund" ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getFundFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === "fund" ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                                <div 
                                    className={`cursor-pointer p-3 rounded-lg transition-colors ${
                                        activeFilterSection === "showFundsBy" ? "bg-[#BC8B20] text-white" : "hover:bg-gray-100"
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === "showFundsBy" ? null : "showFundsBy")}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2">
                                            <span className="font-medium">Show Funds By</span>
                                            {getShowFundsByFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-2 py-1 min-w-[20px] text-center ${activeFilterSection === "showFundsBy" ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getShowFundsByFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === "showFundsBy" ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>
                            </div>

                            {/* Right column - Filters (70%) */}
                            <div className="overflow-visible mt-4 md:mt-0 pb-20 md:pb-0 md:col-span-6">
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-6 ${activeFilterSection === "fund" ? '' : 'hidden'}`}>
                                    <FundSectorFilter
                                        fundSectorOptions={fundSectorOptions}
                                        setFundSectorOptions={setFundSectorOptions}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'fundSector'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'fundSector' : null)}
                                    />

                                    <FundSizeFilter
                                        MinFundOptions={MinFundOptions}
                                        setMinFundOptions={setMinFundOptions}
                                        MaxFundOptions={MaxFundOptions}
                                        setMaxFundOptions={setMaxFundOptions}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'fundSize'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'fundSize' : null)}
                                    />

                                    <FundStatusFilter
                                        FundStatusOptions={FundStatusOptions}
                                        setFundStatusOptions={setFundStatusOptions}
                                        FundStatusSuboptions={FundStatusSuboptions}
                                        setFundStatusSuboptions={setFundStatusSuboptions}
                                        customPathname={customPathname}
                                        updateSubOptions={updateSubOptions}
                                        isSuboptionsFetch={isSuboptionsFetch}
                                        isPopupOpen={openFilterPopup === 'fundStatus'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'fundStatus' : null)}
                                    />

                                    <CapitalSourceFilter
                                        CapitalSourceOptions={CapitalSourceOptions}
                                        setCapitalSourceOptions={setCapitalSourceOptions}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'capitalSource'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'capitalSource' : null)}
                                    />
                                </div>

                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 gap-y-6 ${activeFilterSection === "showFundsBy" ? '' : 'hidden'}`}>
                                    <FundInvestor 
                                        options={fundInvestorsOptions}
                                        setOptions={setFundInvestorsOptions}
                                        customPathname={customPathname}
                                        label="Investors"
                                    />
                                    <Fund 
                                        options={fundsOptions}
                                        setOptions={setFundsOptions}
                                        customPathname={customPathname}
                                        label="Funds"
                                    />
                                </div>

                                <div className={`flex items-center justify-center h-40 text-gray-500 ${activeFilterSection ? 'hidden' : ''}`}>
                                    <p>Select a filter category from the left to view available filters</p>
                                </div>
                            </div>
                        </div>
                    </main>
                </form>
            </div>
        </div>
    );
}
